/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest$inboundSchema:
  z.ZodType<
    ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    "X-On-Behalf-Of": z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      "X-On-Behalf-Of": "xOnBehalfOf",
    });
  });
/** @internal */
export type ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest$Outbound =
  {
    "X-On-Behalf-Of"?: string | undefined;
  };

/** @internal */
export const ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest$outboundSchema:
  z.ZodType<
    ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest$Outbound,
    z.ZodTypeDef,
    ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest
  > = z.object({
    xOnBehalfOf: z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      xOnBehalfOf: "X-On-Behalf-Of",
    });
  });

export function listRepositoriesApiV1SandboxGithubRepositoriesGetRequestToJSON(
  listRepositoriesApiV1SandboxGithubRepositoriesGetRequest:
    ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest,
): string {
  return JSON.stringify(
    ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest$outboundSchema
      .parse(listRepositoriesApiV1SandboxGithubRepositoriesGetRequest),
  );
}
export function listRepositoriesApiV1SandboxGithubRepositoriesGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListRepositoriesApiV1SandboxGithubRepositoriesGetRequest' from JSON`,
  );
}
